<template>
  <div class="wg-empty-ui">
    <div
      class="wg-empty-ui__cards"
      :class="{ 'wg-empty-ui__cards--single': singleCardLayout }"
    >
      <div v-if="showAuditCard" class="wg-empty-ui-card">
        <div class="wg-empty-ui-card__illustration wg-empty-ui-card__illustration--audit">
          <img src="/static/wg_order_audit_illustration.svg" alt="Order audit" />
        </div>
        <div class="wg-empty-ui-card__content">
          <h3 class="wg-empty-ui-card__title">Order your audit</h3>
          <p class="wg-empty-ui-card__text">
            If you want to run audit for your site, you can order audit whenever you're ready.
            We recommend auditing your content every 3-4 months as your content evolves.
          </p>
          <router-link
            :to="{ name: 'OrderContentAuditWhiteGlove', params: { siteId: $route.params.siteId } }"
            class="wg-empty-ui-card__cta"
          >
            Order audit
            <i class="material-icons">add</i>
          </router-link>
        </div>
      </div>

      <div v-if="showContentCard" class="wg-empty-ui-card">
        <div class="wg-empty-ui-card__illustration">
          <img src="/static/wg_order_content_illustration.svg" alt="Order content" />
        </div>
        <div class="wg-empty-ui-card__content">
          <h3 class="wg-empty-ui-card__title">Order your content</h3>
          <p class="wg-empty-ui-card__text">
            Put us to work on your silo by selecting your Top-level page and supporting pages,
            then place the order for your POP team. When your order is ready, we will send you an email.
          </p>
          <router-link
            :to="{ name: 'OrderContentOnlyWhiteGlove', params: { siteId: $route.params.siteId } }"
            class="wg-empty-ui-card__cta"
          >
            Order content
            <i class="material-icons">add</i>
          </router-link>
        </div>
      </div>
    </div>

    <div v-if="showFooter" class="wg-empty-ui__footer">
      <div class="wg-empty-ui__footer-main">
        <i class="material-icons">search</i>
        <span>No orders found.</span>
      </div>
      <p class="wg-empty-ui__footer-sub">Please choose what you need and place the order</p>
    </div>
  </div>
</template>

<script>
const CARD_KEYS = ['audit', 'content']

export default {
  name: 'WhiteGloveEmptyUI',
  props: {
    /** Which cards to render, e.g. ['audit', 'content'] (default) or ['content'] only. */
    cards: {
      type: Array,
      default: () => ['audit', 'content'],
      validator (value) {
        if (!Array.isArray(value) || value.length === 0) {
          return false
        }
        return value.every((key) => CARD_KEYS.includes(key))
      },
    },
    /** When false, hides the “No orders found” footer block. */
    showFooter: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    showAuditCard () {
      return this.cards.includes('audit')
    },
    showContentCard () {
      return this.cards.includes('content')
    },
    singleCardLayout () {
      return this.cards.length === 1
    },
  },
}
</script>

<style lang="scss" scoped>
.wg-empty-ui {
  padding: 30px 20px 20px;
}

.wg-empty-ui__cards {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  justify-content: flex-start;

  &--single .wg-empty-ui-card {
    flex: 0 1 720px;
    max-width: 100%;
  }
}

.wg-empty-ui-card {
  flex: 1;
  display: flex;
  gap: 30px;
  align-items: center;
  padding: 24px;
  background: #fff;
  border: 1px solid var(--v-gray12Color-base);
  border-radius: 12px;
}

.wg-empty-ui-card__illustration {
  flex-shrink: 0;
  width: 45%;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.wg-empty-ui-card__illustration--audit {
  background: #f3f4fa;
}

.wg-empty-ui-card__content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.wg-empty-ui-card__title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--v-mainColor-base);
  margin: 0;
}

.wg-empty-ui-card__text {
  font-size: 0.85rem;
  font-weight: 400;
  line-height: 1.5;
  color: #363636;
  margin: 0;
}

.wg-empty-ui-card__cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 20px;
  height: 32px;
  background: var(--v-profileAnchorColor-base);
  color: #fff;
  border: none;
  border-radius: 30px;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  width: fit-content;
  text-decoration: none;
  box-sizing: border-box;
  transition: opacity 0.2s;

  .material-icons {
    font-size: 20px;
  }

  &:hover {
    opacity: 0.85;
  }
}

.wg-empty-ui__footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 13px;
  margin-top: 30px;
}

.wg-empty-ui__footer-main {
  display: flex;
  align-items: center;
  gap: 13px;

  .material-icons {
    font-size: 40px;
    color: var(--v-gray12Color-base);
  }

  span {
    font-size: 32px;
    font-weight: 800;
    color: var(--v-gray12Color-base);
  }
}

.wg-empty-ui__footer-sub {
  font-size: 22px;
  font-weight: 800;
  color: var(--v-gray12Color-base);
  margin: 0;
}
</style>
